import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId } from 'app/resources/classes';
import 'bootbox';

@Component({
  selector: 'app-loja-vitrine',
  templateUrl: './loja-vitrine.component.html'
})
export class LojaVitrineComponent implements OnInit {

  public processandoProdutoSelecionadoValor: boolean;
  public processandoProduto: boolean;
  public exibeListaParceiros: boolean;
  public parceiroSelecionado: any;
  public aberto: boolean;
  public termoBusca: string;
  public pesquisarNaCategoriaAtual: boolean;
  public breadcrumbCategorias: any;
  public produtoSelecionado: any;
  private LIMITE_POR_PAGINA = 16;
  public limitePorPagina: any;
  public opcaoOrdenacao: any;
  public opcoesOrdenacao: any;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor(public mainService: MainService, public router: Router) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.exibeListaParceiros = false;
    this.aberto = false;
    this.termoBusca = '';
    this.pesquisarNaCategoriaAtual = false;
    this.opcoesOrdenacao = {
      'pontosCrescente': 'Menor Preço',
      '-pontos': 'Maior Preço',
      '+nome': 'A-Z',
      '-nome': 'Z-A',
    };
    this.opcaoOrdenacao = 'A-Z';

    this.parceiroSelecionado = this.mainService.lojaCarrinho.parceiro;
    this.resetLimitePorPagina();
  }

  public selecionarParceiro(parceiro) {
    this.parceiroSelecionado = parceiro;
    this.trocarParceiro();
    this.aberto = false;
    this.exibeListaParceiros = false;
  }

  public trocarParceiro() {
    const that = this;
    if (this.mainService.lojaCarrinho.itens.length &&
      this.mainService.lojaCarrinho.parceiro.id !== this.parceiroSelecionado.id) {

      const mensagem = bootbox.confirm({
        message: 'Ao trocar de parceiro, seus produtos no carrinho serão descartados! Deseja continuar?',
        buttons: {
          confirm: {
            label: 'Sim',
            className: 'btn-danger'
          },
          cancel: {
            label: 'Não',
            className: 'app-btn-best'
          }
        },
        callback: function (result) {
          if (result) {
            that.mainService.lojaCarrinho.clean();
            that.resetarParceiro();
          } else {
            that.parceiroSelecionado = that.mainService.lojaCarrinho.parceiro;
          }
        }
      });
      mensagem.on('shown.bs.modal', function () {
        $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
        $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
        $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
        $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
      });
    } else if (!that.mainService.lojaCarrinho.parceiro ||
      that.mainService.lojaCarrinho.parceiro.id !== this.parceiroSelecionado.id) {
      that.resetarParceiro();
    }
  }

  public resetarParceiro() {
    this.termoBusca = '';
    this.pesquisarNaCategoriaAtual = false;
    this.goVitrine(this.parceiroSelecionado);
  }

  public goVitrine(parceiro) {
    this.resetPaginacao();
    this.termoBusca = undefined;
    this.breadcrumbCategorias = [];
    this.mainService.lojaService.goVitrine(parceiro);
    this.aberto = false;
  }

  public resetPaginacao() {
    this.produtoSelecionado = undefined;
    this.resetLimitePorPagina();
  }

  public resetLimitePorPagina() {
    this.limitePorPagina = this.LIMITE_POR_PAGINA;
  }

  public carregarMaisProdutos() {
    this.limitePorPagina += this.LIMITE_POR_PAGINA;
  }

  public buscarPorTermo() {
    if (this.termoBusca) {
      this.resetPaginacao();
      if (this.pesquisarNaCategoriaAtual) {
        this.mainService.lojaService.buscarPorTermoNaCategoriaSelecionada(this.termoBusca);
      } else {
        this.mainService.lojaService.buscarPorTermo(this.termoBusca);
      }
    }
  }

  public gerarBreadcrumb(categoria) {
    if (!this.breadcrumbCategorias.length) {
      this.breadcrumbCategorias.push(Object.assign(categoria));
    } else {
      const breadcrumbCategorias = [];
      for (let i = 0; i < this.breadcrumbCategorias.length; i++) {
        if (this.breadcrumbCategorias[i].arvore === categoria.arvore) {
          break;
        } else {
          breadcrumbCategorias.push(Object.assign(this.breadcrumbCategorias[i]));
        }
      }
      breadcrumbCategorias.push(Object.assign(categoria));
      this.breadcrumbCategorias = Object.assign([], breadcrumbCategorias);
    }
  }

  public carregarSubCategorias(categoria) {
    this.termoBusca = '';
    this.pesquisarNaCategoriaAtual = false;
    this.resetPaginacao();
    this.gerarBreadcrumb(categoria);
    this.mainService.lojaService.carregarSubCategorias(categoria);
    this.aberto = false;
  }

  public abrir() {
    if (this.aberto) {
      this.aberto = false;
    } else if (!this.aberto) {
      this.aberto = true;
    }
  }

  public selecionarProduto(produto) {
    this.rolarParaTopo();

    this.produtoSelecionado = produto;
    this.produtoSelecionado.imagens = [produto.url];
    this.processandoProduto = true;
    this.processandoProdutoSelecionadoValor = true;

    this.mainService.http.pathRest().get('loja/parceiros/' + this.parceiroSelecionado.id + '/' +
      this.parceiroSelecionado.uuid + '/produtos/' + produto.sku + '/?atualizado=false', true)
      .subscribe(
      sucesso => {
        this.produtoSelecionado = sucesso.json();
        this.processandoProduto = false;
        this.mainService.http.pathRest().get('loja/parceiros/' + this.parceiroSelecionado.id + '/' +
          this.parceiroSelecionado.uuid + '/produtos/' + produto.sku + '/?atualizado=true', true)
          .subscribe(
          data => {
            this.produtoSelecionado = data.json();
            this.atualizaProdutosService();
            this.processandoProdutoSelecionadoValor = false;
          }, erro => {
            this.produtoSelecionado.disponivel = false;
            this.atualizaProdutosService();
            this.processandoProdutoSelecionadoValor = false;
          });
      });
  }

  public atualizaProdutosService() {
    for (let i = 0; i < this.mainService.lojaService.produtos.length; i++) {
      if (this.mainService.lojaService.produtos[i].sku === this.produtoSelecionado.sku) {
        this.mainService.lojaService.produtos[i] = this.produtoSelecionado;
        break;
      }
    }

    this.processandoProduto = false;
  }

  public adicionarAoCarrinho() {
    this.mainService.lojaCarrinho.add(this.produtoSelecionado);
    this.produtoSelecionado = undefined;
    this.bootboxAlertComId.alerta('Produto adicionado ao carrinho!');
  }

  public irAoCarrinho() {
    this.mainService.lojaCarrinho.add(this.produtoSelecionado);
    this.router.navigate(['/loja/carrinho']);
  }

  public deselecionarProduto() {
    this.rolarParaTopo();
    this.produtoSelecionado = undefined;
  }

  public rolarParaTopo() {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/loja/loja-vitrine/loja-vitrine.component.ts